import { sliderClasses } from "@mui/material";
import { typography } from "../../themes/typography/typography.js";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
const rootStyles = {
  color: "primary.800",
  "&.Mui-disabled": {
    color: "grey.400"
  },
  [`& .${sliderClasses.thumb}`]: {
    "&:hover, &:focus, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "0px 0px 0px 10px rgba(0, 98, 79, 0.12)"
    },
    [`&.Mui-disabled .${sliderClasses.valueLabel}`]: {
      backgroundColor: "grey.400"
    }
  },
  [`& .${sliderClasses.track}`]: {
    border: "unset"
  },
  [`& .${sliderClasses.rail}`]: {
    opacity: "0.08"
  },
  [`& .${sliderClasses.mark}`]: {
    backgroundColor: "grey.400"
  },
  [`& .${sliderClasses.valueLabel}`]: {
    ...typography["Lato Emphasized 2"],
    background: "unset",
    padding: 0,
    width: 28,
    height: 28,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "primary.800",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": {
      display: "none"
    },
    [`&.${sliderClasses.valueLabelOpen}`]: {
      transform: "translate(50%, -80%) rotate(-45deg) scale(1)"
    },
    "& > *": {
      transform: "rotate(45deg)"
    }
  }
};
export {
  rootStyles
};
